import React from 'react';
const BONUSES = [{
  title: 'Bono #1 – Checklist Diario del Sueño',
  desc: 'Para saber exactamente qué hacer cada día.',
  value: '$15.000',
  img: 'https://cdn.magicpatterns.com/uploads/pQ2JMfaFq5AkXRhWKY8jJ1/mockup_final_BONO_1_Dormir_mejor_desde_el_amor.png'
}, {
  title: 'Bono #2 – Guía Rápida por Edad (0 a 24 meses)',
  desc: 'Porque cada etapa es distinta.',
  value: '$12.000',
  img: 'https://cdn.magicpatterns.com/uploads/2xPTgY2AjTo9ZyTDXwbu9e/mockup_final_BONO_2_Dormir_mejor_desde_el_amor.png'
}, {
  title: 'Bono #3 – Plan de Emergencia para Noches Difíciles',
  desc: 'Regresiones, brotes, enfermedades. No estás sola.',
  value: '$10.000',
  img: 'https://cdn.magicpatterns.com/uploads/j98XPreuFsGejBKiCgJSNo/mockup_final_BONO_3_Dormir_mejor_desde_el_amor.png'
}];
export function Bonuses() {
  return <section className="py-16 px-4 bg-gradient-to-b from-white to-yellow-50" data-id="element-11">
      <div className="max-w-6xl mx-auto" data-id="element-12">
        <div className="text-center mb-12" data-id="element-13">
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-14">
            🎁 REGALOS ESPECIALES – BONOS INCLUIDOS HOY
          </h2>
          <p className="text-xl text-green-600 font-bold uppercase tracking-wide" data-id="element-15">
            (Sin costo adicional – GRATIS por hoy)
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-16">
          {BONUSES.map((bonus, i) => <div key={i} className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 flex flex-col transform hover:-translate-y-1 transition-transform duration-300" data-id="element-17">
              <div className="p-6 bg-gray-50 flex justify-center items-center h-80" data-id="element-18">
                <img src={bonus.img} alt={bonus.title} className="w-full h-full object-contain drop-shadow-lg" data-id="element-19" />
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-20">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-21">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 mb-4 flex-1" data-id="element-22">{bonus.desc}</p>
                <div className="pt-4 border-t border-gray-100" data-id="element-23">
                  <p className="text-sm text-gray-500 line-through" data-id="element-24">
                    Valor: {bonus.value}
                  </p>
                  <p className="text-lg font-bold text-green-600" data-id="element-25">
                    HOY: GRATIS
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}